import React, { useEffect, useState, useMemo } from "react";
import ProductDataFilter from "../../../components/product-data-filter/product-data-filter";
import GenericDataChart from "../../../GenericPageElements/GenericDataChart";
import GenericPageContainer from "../../../GenericPageElements/GenericPageContainer";
import GenericProductFilterContainer from "../../../GenericPageElements/GenericProductFilterContainer";
import endpoints from "../../../helpers/endpoints";
import hasPermission from '../../../helpers/permissions';
import request from "../../../helpers/request";
import S3Modal from "../../../components/s3Modal/S3Modal";
import session from "../../../stores/session";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";
import { view } from "@risingstack/react-easy-state";
import { Link } from "react-router-dom";
import BulkBuy from '../../../components/cot-alert-bulk-buy/bulkBuy';
import BulkAllocate from '../../../components/cot-alert-bulk-allocate/bulkAllocate';
import { CustomizedAxisTickMultiLine } from "../../../components/GraphComponents";
import './MoslDqa.scss';
import { LoadingForGraphTable, SharedChartColours } from "../../../GenericPageElements/GenericDataChart";
import DataGroupings from "../../../components/data-groupings/data-groupings";
import ProductChartInfo from "../../../components/product-chart-info/product-info-chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, Tooltip } from 'recharts';
const localised = Intl.NumberFormat("en-GB");

export default view(function MoslDqaSummary() {
  const [filters, setFilters] = useState({});
  const [selectedGroupBy, setSelectectGroupBy] = useState("");
  const [data, setData] = useState(null);
  const [dates, setDates] = useState([]);
  const [date, setDate] = useState(null);
  const [groupings, setGroupings] = useState([]);
  const [displayMode, setDisplayMode] = useState('graph')
  const [dataReady, setDataReady] = useState(false)
  const [S3Model, setS3Model] = useState(null);
  const [bulkModel, setBulkModel] = useState('')
  
  const applyFilter = (column, value) => {
    setFilters((current) => {
      return {
        ...current,
        [column]: value,
      };
    });
  };

  useEffect(() => {
    request(true)
      .get(endpoints.MOSL_DQA_DATES)
      .then((e) => {
        setDates(e.data.dates);
        if (e.data.dates.length > 0) setDate("All_Refreshes");
      });
  }, []);

  useEffect(() => {
    if (!date) return;
    request(true)
      .get(endpoints.MOSL_DQA_DATA, {
        doesCancel: true,
        params: {
          date: date,
          filter: filters,
          group: selectedGroupBy,
        },
      })
      .then((e) => {
        setData(e.data);
        setDataReady(true)
      });
  }, [filters, selectedGroupBy, date]);

  const totals = useMemo(() => {
    if (!data) return []
    if (data.keys.length < 1) {
      return new Array(( Object.keys(data.columns).length * data.graphColumns.length ) + 1).fill(0)
    }
    let totalsArray = new Array(data.data[data.keys[0]].length).fill(0)
    totalsArray = totalsArray.map((totals, index) => {
      let total = 0;
      data.keys.forEach(key => {
        total += data.data[key][index]
      });
      return (
        total
      )
    })
    totalsArray.push(Object.values(data.groupTotals).reduce((partialSum, a) => partialSum + a, 0))
    return totalsArray
  }, [data])

  const CustomTooltip = ({ active, payload, label, data }) => {
    if (!active || !payload || !payload.length || !data) return null;
    const group = payload[0].payload.group;
    const groupData = data?.graphColumns.filter(item => item.group === group) ?? [];
    const dataKey = data.keys[0]
    
    return (
      <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: 10, display: 'grid', gridGap: 5 }}>
        <h4>{group}</h4>
        {groupData.map((item) => {
          return (
            Object.keys(data.columns).map((column, index) => {
              const dataValue = item[`${column}-${dataKey}`]
              return (
                <>
                  <span style={{ margin: '0px' }}>{column}: {localised.format(dataValue)}</span>
                </>
              )
            })
          )
        })}
      </div>
    );
  };

  const borderStyling = 'white 1px solid'

  return [
    <GenericPageContainer
      title="MOSL: DQA - Summary"
      titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
      containerWidth={'92vw'}
      titleRight={
        <div>
          <Link className="navigate" to="/portal/mosl-dqa/search">
              Single SPID View
          </Link>
          {hasPermission('MOSL_DQA', 'DOWNLOAD') ? (
            <button className="navigate" onClick={() => setS3Model("download")}>
              Download Return File
            </button>
          ) : null}
        </div>
      }
    >
      <div className="grid grid-gap-15" style={{marginBottom: 15, gridAutoFlow: 'column', maxWidth: '40%'}}>
        <GenericDataRow title={"File Date"} contentColour={"white"}>
          <select
            onChange={(_) => setDate(_.target.value)}
            value={date}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              paddingLeft: "10px",
            }}
          >
            {dates.map((item) => {
              return (
                <option key={item.raw} value={item.raw}>
                  {item.pretty}
                </option>
              );
            })}
          </select>
        </GenericDataRow>
        <div className="data-row display-type grid-gap-15">
          <select
            onChange={(_) => setDisplayMode(_.target.value)}
            value={displayMode}
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              paddingLeft: "10px",
            }}
          >
            <option value="table">Table</option>
            <option value="graph">Graph</option>
          </select>
          <div className="grid grid-gap-15" style={{ gridAutoFlow: 'column' }}>
            { session.company.mosl_dqa_user_guide_video_url &&
              <div className="grid" style={{ gridAutoFlow: 'column', alignItems: 'center', gridTemplateColumns: 'max-content'}}>
                <span>User Guide:</span>
                <ProductChartInfo video={session.company.mosl_dqa_user_guide_video_url} path={window.location.pathname} />
              </div>
            }
            { session.company.mosl_dqa_admin_guide_video_url &&
              <div className="grid" style={{ gridAutoFlow: 'column', alignItems: 'center', gridTemplateColumns: 'max-content'}}>
                <span>Admin Guide:</span>
                <ProductChartInfo video={session.company.mosl_dqa_admin_guide_video_url} path={window.location.pathname} />
              </div>
            }
          </div>
        </div>
      </div>
      <div className='MDQA'>
        <div>
          <div className={`vcv-table-or-graph using-${displayMode}`}>
            { !dataReady ? (
              <LoadingForGraphTable />
            ) : (
              <>
                { displayMode === "table" ? (
                  <table className="table borders scale-text">
                    <thead>
                      <tr>
                        <th></th>
                        { data.defaultGroup.map(group => {
                          return (
                            <th 
                              colSpan={Object.keys(data.columns).length}
                              style={{ borderLeft: borderStyling, borderRight: borderStyling }}
                            >
                              {group}
                            </th>
                          )
                        })}
                        <th></th>
                      </tr>
                      <tr>
                        <th>{groupings.find(group => group.target_column === selectedGroupBy)?.title}</th>
                        {data.defaultGroup.map(group => {
                          return (
                            Object.keys(data.columns).map((columName, index) => {
                              return (
                                <th style={{ 
                                  borderTop: borderStyling,
                                  borderLeft: borderStyling,
                                  borderRight: index === Object.keys(data.columns).length - 1 && borderStyling
                                }}>
                                  {columName}
                                </th>
                              )
                            })
                          )
                        })}
                        <th className="no-radius bold" style={{borderTop: borderStyling}}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.keys.map(item => {
                        return (
                          <tr key={`summary-data-${Math.random()}`}>
                            <td>{item}</td>
                            {data.data[item].map(value => {
                              return (
                                <td>{localised.format(value)}</td>
                              )
                            })}
                            <td>{localised.format(data.groupTotals[item])}</td>
                          </tr>
                        )
                      })}
                      <tr>
                        <td>Total</td>
                        {
                          totals.map(total => {
                            return (
                            <td>{localised.format(total)}</td>
                            )
                          })
                        }
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <ResponsiveContainer height={600} width='98%' debounce={1}>
                    <BarChart 
                      data={data?.graphColumns}
                      barGap={50}
                    >
                      <Legend iconType={"none"} iconSize={0} margin={20} 
                        wrapperStyle={{  paddingTop: '40px' }}
                        payload={data.keys.map((key, index) => {
                          return ''
                        })}
                        formatter={(value) => {
                          return (
                            <span>{value}</span>
                          )
                        }}
                      />
                      <XAxis dataKey="group" 
                      tick={({ x, y, payload }) => {
                        // Evenly space sublabels based on barwidth of 50, barsize of 50
                        const xValues = Array.from({ length: Object.keys(data.columns).length }, (_, i) => (i - (Object.keys(data.columns).length - 1) / 2) * 100); 
                        return (
                          <>
                            <line x1={x + xValues[0] - 50} y1={y - 8} x2={x + xValues[0] - 50} y2={y + 15} stroke="#666" strokeWidth={1} />
                            <line x1={x + xValues[xValues.length - 1] + 50} y1={y - 8} x2={x + xValues[xValues.length - 1] + 50} y2={y + 15} stroke="#666" strokeWidth={1} />
                            <g transform={`translate(${x}, ${y})`}>
                              <text x={0} y={0} dy="0.71em" textAnchor="middle" fill="#666" fontWeight="bold">
                                {payload.value}
                              </text>
                              { Object.keys(data.columns).map((col, index) => {
                                return (
                                  <text key={col} x={xValues[index]} y={45} textAnchor="middle" fontSize={12}>
                                    {col}
                                  </text>
                                )
                              })}
                            </g>
                          </>
                        )
                      }}
                      />
                      <YAxis
                        type="number"
                        allowDecimals={false}
                        tick={{ fontSize: 12 }}
                        tickFormatter={(item) => {
                          return localised.format(item);
                        }}
                      />
                      <CartesianGrid />
                      <Tooltip cursor={true} content={<CustomTooltip data={data}/> } />
                      {
                        data.keys.map((key, keyIndex) => {
                          return (
                            Object.keys(data.columns).map((column, columnIndex) => {
                              const totalIndex = keyIndex * Object.keys(data.columns).length + columnIndex
                              return (
                                <Bar barSize={50} key={totalIndex} dataKey={`${column}-${key}`} stackId={column} fill={SharedChartColours[keyIndex % SharedChartColours.length]} />
                              );
                            })
                          );
                        })
                      }
                    </BarChart>
                  </ResponsiveContainer>
                )}
              </>
            )}
          </div>
        </div>
        <GenericProductFilterContainer clearFilters={() => setFilters({})}>
          <ProductDataFilter
            filterState={filters}
            applyFilter={applyFilter}
            dataFilterEndpoint={endpoints.MOSL_DQA_FILTERS}
          />
          <div className='grid grid-columns-2 grid-gap-5 mta'>
              { (hasPermission('MOSL_DQA', 'BULK-BUY')) ?
                  <button style={{  gridColumn: 'span 2' }} className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('purchase')}>
                      Create Download File
                  </button>
              : '' }
          </div>
        </GenericProductFilterContainer>
      </div>
    </GenericPageContainer>,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      showModal={!!S3Model}
      listingUrl={endpoints.MOSL_DQA_FILES}
      uploadUrl={endpoints.MOSL_DQA_FILES}
    />,
    <BulkBuy 
    SentenceFirst={({count}) => <>The selected data set includes {count} SPIDs to be downloaded. Press the 'Create File' button to create the download file and you will receive an email notification once this is available. Alternatively press the 'Cancel' button to go back to the summary screen.</>}
    SentenceSecond={() => <></>}
    purchaseLabel="Download Limit:"
    buyButtonText="Create File"
    completeOnFirstStep={true} 
    workflowUsersEndpoint={endpoints.MOSL_DQA_WF_USERS} 
    bulkEndpoint={endpoints.MOSL_DQA_BULK_BASE} 
    modalIsOpen={bulkModel === 'purchase'} 
    closeModal={() => setBulkModel('')} 
    filters={filters} 
    date={date} />
  ];
})
